import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import style from "./index.module.scss";
import MessageItem from "./Components/MessageItem";
import { useSession } from "../../Utils/useSession";
import { useUpdateMessage } from "../../Utils/useUpdateMessage";
import { useSender } from "../../Utils/useSender";
import { ChatMessageItem } from "../../types";

import RightMenu from "../RightMenu";
import {
    errorMessage,
    ResultMessage,
    deleteMessage,
    isTrue,
    setHasRead
} from "../../polyfills";
import useUpdateSessionList from "../../Utils/useUpdateSessionList";
import useMessageScroll from "../../Utils/useMessageScroll";
import { makeSenderFlag } from "../../Utils/common";
import { useAtomValue } from "jotai";
import { userAtom } from "../../store";
import { useAsync } from "react-use";
import useUpdateSession from "../../Utils/useUpdateSession";
import WaterMark from "./Components/WaterMark";
import { ContextEvent } from "./Components/MessageItem/Components/MessageContent";

interface MessageListProps {
    sessionId: string;
}

export default function MessageList({ sessionId }: MessageListProps) {
    const { session } = useSession(sessionId);
    const sessionManager = useUpdateSession();

    const { removeMessage } = useUpdateMessage();
    const updateSessionList = useUpdateSessionList();

    const { senderFlag } = useAtomValue(userAtom);
    const scroller = useMessageScroll();
    const sender = useSender();

    const menuRef = useRef<any>(null);

    //消息记录
    const messages = session?.chatMessages || [];

    const [selectedMsg, setSelectedMsg] = useState<ChatMessageItem>();

    // 标记当前session为已读
    useAsync(async () => {
        try {
            await setHasRead([sessionId]);
            sessionManager.markSessionRead(sessionId);
        } catch (e) {
            // 出错不做处理, 因为并不重要, 并且用户也无法处理
        }
    }, [sessionId]);

    useLayoutEffect(() => {
        scroller.scrollToBottom();
    }, []);

    // 撤回消息
    const handleRetract = () => {
        if (!selectedMsg) return;
        sender.retractMessage(selectedMsg);
        removeMessage(sessionId, selectedMsg.guid);
        updateSessionList();
    };

    //删除消息
    const handleDelete = async () => {
        if (!selectedMsg) return;

        try {
            await deleteMessage(selectedMsg.sessionUid, selectedMsg.guid);
            removeMessage(sessionId, selectedMsg.guid);
            updateSessionList();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    //监听右键事件
    const onContextMenu = (e: ContextEvent, message: ChatMessageItem) => {
        e.preventDefault?.();

        // 已被举报的消息无法右键
        if (isTrue(message.isAccused)) return;

        setSelectedMsg(message);

        const isSender = makeSenderFlag(message.sender) === senderFlag;

        const offsetX = isSender ? -110 : 0;

        menuRef.current.style.left = e.clientX + offsetX + "px";
        menuRef.current.style.top = e.clientY + "px";
        menuRef.current.style.display = "block";
    };

    const _handleClick = () => {
        if (!menuRef?.current?.style) return;
        menuRef.current.style.display = "none";
    };

    useEffect(() => {
        document.addEventListener("click", _handleClick);
        return () => {
            document.removeEventListener("click", _handleClick);
        };
    }, []);

    return (
        <div className={`${style.container} WebIM-List`}>
            <WaterMark />

            <div className={style.list} id="ChatMessageList">
                {messages.map((message, index) => (
                    <MessageItem
                        key={message.guid}
                        index={index}
                        sessionId={sessionId}
                        message={message}
                        preMessage={messages[index - 1]}
                        onContextMenu={(e: any) => onContextMenu(e, message)}
                    />
                ))}
            </div>

            <div
                ref={menuRef}
                style={{
                    position: "fixed",
                    display: "none"
                }}>
                {selectedMsg && (
                    <RightMenu
                        msg={selectedMsg}
                        handleRetract={handleRetract}
                        handleDelete={handleDelete}
                    />
                )}
            </div>
        </div>
    );
}
